/**
 * The alternate-emails convention every invitation form shares.
 *
 * @module components/shared/address-list
 */

/** Parse a comma- or newline-separated address list, dropping the gaps. */
export function parseAddressList(value: string): string[] {
  return value
    .split(/[,\n]/)
    .map((entry) => entry.trim())
    .filter(Boolean);
}
